import { render, staticRenderFns } from "./FileContentBlockForm.vue?vue&type=template&id=40245cc4&"
import script from "./FileContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./FileContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports